import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=75912c19"
import script from "./DocumentManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentManager.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports